
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regular-page",
      function () {
        return require("private-next-pages/regular-page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regular-page"])
      });
    }
  